export const CALC_RISKMATRIX_FAILURE = 'CALC_RISKMATRIX_FAILURE';
export const CALC_RISKMATRIX_SUCCESS = 'CALC_RISKMATRIX_SUCCESS';
export const CALC_RISKMATRIX_REQUEST = 'CALC_RISKMATRIX_REQUEST';
export const UPDATE_REPORTING_SCOPEFILTER = 'UPDATE_REPORTING_SCOPEFILTER';
